import type { DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { EditVarianceType } from '@webapp/platform/iam/entities/enums/EditVarianceTypeEnum'
import { useQueryUserPurchasePriceLimit } from '@webapp/platform/iam/features/get-user-purchase-price-limit/models/useQueryUserPurchasePriceLimit'

export const useUserPurchasePriceLimitPresenter = ({
  userId,
}: {
  userId: DetailedUser['id']
}) => {
  const {
    data: { purchasePriceLimit },
    states: { isFetching },
  } = useQueryUserPurchasePriceLimit({ userId })

  return {
    data: { purchasePriceLimit },
    states: {
      showLoader: isFetching || !purchasePriceLimit,
      showDefaultPurchasePriceVarianceSettings:
        !purchasePriceLimit?.restrictEditableVariance,
      showPurchasePriceLimitInPercentage:
        purchasePriceLimit?.editVarianceType === EditVarianceType.PERCENTAGE,
    },
  }
}
